import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';
import i18n from 'i18next';

type PreviousEmploymentTypeOption = {
  name: string;
  value: EmploymentType;
};

export const previousEmploymentTypeOptions: PreviousEmploymentTypeOption[] = [
  {
    name: i18n.t('previousEmploymentType.fullTime'),
    value: EmploymentType.FULL_TIME,
  },
  {
    name: i18n.t('previousEmploymentType.partTime'),
    value: EmploymentType.PART_TIME,
  },
  {
    name: i18n.t('previousEmploymentType.selfEmployed'),
    value: EmploymentType.SELF_EMPLOYED,
  },
  {
    name: i18n.t('previousEmploymentType.military'),
    value: EmploymentType.ACTIVE_MILITARY,
  },
  {
    name: i18n.t('previousEmploymentType.student'),
    value: EmploymentType.STUDENT,
  },
  {
    name: i18n.t('previousEmploymentType.homemaker'),
    value: EmploymentType.HOMEMAKER,
  },
  {
    name: i18n.t('previousEmploymentType.retired'),
    value: EmploymentType.RETIRED,
  },
  {
    name: i18n.t('previousEmploymentType.disability'),
    value: EmploymentType.DISABILITY,
  },
  {
    name: i18n.t('previousEmploymentType.other'),
    value: EmploymentType.OTHER,
  },
];
